module.exports = __webpack_public_path__ + "img/116.b8d7cb4d.jpg";